// extracted by mini-css-extract-plugin
export default {"base":"ColumnChartDisplay_base__1-Brr","select":"ColumnChartDisplay_select__ddbBj"};